// Full-document render of the Oscar account-login view: PageSkeleton (the
// React document shell) wrapping LoginPageBody.
import React from "react";

import { templates } from "@reactivated";

import { LoginPageBody } from "../components/LoginPageBody";
import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (
    props: templates.LoginDocumentTemplate,
): React.JSX.Element => {
    return (
        <PageSkeleton pageChrome={props.page_chrome}>
            <LoginPageBody {...props} />
        </PageSkeleton>
    );
};
